import React from "react";
import ReactDOM from "react-dom";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { Spinner } from "./assets/spinner";


ReactDOM.render(
  <React.StrictMode>
          <App/>
    <Spinner />
  </React.StrictMode>,
  document.getElementById("root")
);